import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { FieldError } from "@/components/form/ConfigField";
import { Counter } from "@/components/admin/ContentFields";

const LIM = { q: 200, a: 800 };

export const validateFaq = (list) => {
    const e = {};
    list.forEach((it, i) => ["q", "a"].forEach((k) => {
        const v = (it[k] || "").trim();
        if (!v) e[`${i}.${k}`] = "Campo obbligatorio";
        else if (v.length > LIM[k]) e[`${i}.${k}`] = `Massimo ${LIM[k]} caratteri`;
    }));
    return Object.keys(e).length ? e : null;
};

const Item = ({ it, i, n, set, move, del, err, readOnly }) => {
    const id = `cms-faq-${i}`;
    const input = (k, Tag, label) => (
        <div className="space-y-1">
            <label htmlFor={`${id}-${k}`} className="text-sm font-semibold">{label} *</label>
            <Tag id={`${id}-${k}`} className="edi-input" rows={Tag === "textarea" ? 3 : undefined} value={it[k]} readOnly={readOnly} aria-required="true"
                onChange={(e) => set(i, k, e.target.value)} aria-invalid={err?.[`${i}.${k}`] ? "true" : "false"}
                aria-describedby={`${id}-${k}-count${err?.[`${i}.${k}`] ? ` ${id}-${k}-error` : ""}`} data-testid={`${id}-${k}-input`} />
            <Counter id={`${id}-${k}-count`} len={it[k].length} limit={LIM[k]} />
            <FieldError id={`${id}-${k}-error`} error={err?.[`${i}.${k}`]} />
        </div>
    );
    return (
        <li className="rounded-xl border border-edi-border p-4 space-y-3" data-testid={`${id}-item`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
                <p className="font-bold">Domanda {i + 1} di {n}</p>
                {!readOnly && (
                    <div className="flex gap-2">
                        <button type="button" className="btn-tertiary py-1 px-3" disabled={i === 0} onClick={() => move(i, -1)} aria-label={`Sposta su la domanda ${i + 1}`} data-testid={`${id}-up`}><ArrowUp aria-hidden="true" size={16} /></button>
                        <button type="button" className="btn-tertiary py-1 px-3" disabled={i === n - 1} onClick={() => move(i, 1)} aria-label={`Sposta giù la domanda ${i + 1}`} data-testid={`${id}-down`}><ArrowDown aria-hidden="true" size={16} /></button>
                        <button type="button" className="btn-tertiary py-1 px-3 text-edi-error" onClick={() => del(i)} aria-label={`Elimina la domanda ${i + 1}`} data-testid={`${id}-delete`}><Trash2 aria-hidden="true" size={16} /></button>
                    </div>
                )}
            </div>
            {input("q", "input", "Domanda")}
            {input("a", "textarea", "Risposta")}
        </li>
    );
};

export const FaqField = ({ value, onChange, errors, readOnly }) => {
    const [focusIdx, setFocusIdx] = useState(null);
    useEffect(() => {
        if (focusIdx === null) return;
        document.getElementById(`cms-faq-${focusIdx}-q`)?.focus();
        setFocusIdx(null);
    }, [focusIdx, value.length]);
    const set = (i, k, v) => onChange(value.map((it, j) => (j === i ? { ...it, [k]: v } : it)));
    const move = (i, d) => {
        const next = [...value];
        [next[i], next[i + d]] = [next[i + d], next[i]];
        onChange(next);
        requestAnimationFrame(() => document.querySelector(`[data-testid=cms-faq-${i + d}-${d < 0 ? "up" : "down"}]:not(:disabled)`)?.focus() || document.getElementById(`cms-faq-${i + d}-q`)?.focus());
    };
    const del = (i) => { onChange(value.filter((_, j) => j !== i)); requestAnimationFrame(() => document.querySelector("[data-testid=cms-faq-add]")?.focus()); };
    const addItem = () => { onChange([...value, { q: "", a: "" }]); setFocusIdx(value.length); };
    return (
        <fieldset className="space-y-3">
            <legend className="edi-label">Domande e risposte</legend>
            <p className="text-sm text-edi-muted">Con almeno una domanda la sezione «Domande frequenti» appare nella home. Domanda massimo 200 caratteri, risposta massimo 800.</p>
            {value.length === 0 && <p className="text-sm" data-testid="cms-faq-empty">Nessuna domanda: la sezione non è visibile nella home.</p>}
            <ol className="space-y-3" aria-label="Domande frequenti">
                {value.map((it, i) => <Item key={i} it={it} i={i} n={value.length} set={set} move={move} del={del} err={errors} readOnly={readOnly} />)}
            </ol>
            {!readOnly && <button type="button" className="btn-secondary py-2" onClick={addItem} data-testid="cms-faq-add"><Plus aria-hidden="true" size={16} /> Aggiungi domanda</button>}
        </fieldset>
    );
};
